export const categoricalScale = [
    "#52BBED",
    "#D20190",
    "#69238F",
    "#C9E238",
    "#EB6038",
    "#8B572A",
]

export const typeScale = {
    "person": "#52BBED",
    "bicycle": "#D20190",
    "motorbike": "#69238F",
    "bus": "#C9E238",
    "car": "#EB6038",
    "truck": "#8B572A",
}

export const categoricalScaleDeck = {
    "person": [82,187,237],
    "bicycle": [210,1,144],
    "motorbike": [105,35,143],
    "bus": [201,226,56],
    "car": [235,96,56],
    "truck": [139,87,42],
}


// WEBPACK FOOTER //
// ./src/modules/colors.js